import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search, MapPin, Briefcase } from "lucide-react";

export const JobsList = () => {
  const [jobs, setJobs] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/jobs").then((r) => setJobs(r.data)).catch(() => {});
  }, []);

  const filtered = jobs.filter((j) => {
    const s = q.toLowerCase();
    if (!s) return true;
    return (j.title + " " + j.company + " " + (j.required_skills || []).join(" ")).toLowerCase().includes(s);
  });

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      <div className="mono-label">explore</div>
      <h1 className="font-display text-3xl font-semibold tracking-tight mt-2">Open positions</h1>

      <div className="mt-6 relative max-w-lg">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
        <Input placeholder="Search title, company or skill" value={q} onChange={(e) => setQ(e.target.value)}
               data-testid="jobs-search-input" className="pl-10 bg-[#111827] border-white/10" />
      </div>

      <div className="mt-8 space-y-3">
        {filtered.map((j) => (
          <Link
            key={j.job_id}
            to={`/jobs/${j.job_id}`}
            className="block border border-white/10 bg-[#111827] rounded-xl p-5 hover:border-white/20 transition-colors"
            data-testid={`job-row-${j.job_id}`}
          >
            <div className="flex flex-col md:flex-row md:items-center gap-4 justify-between">
              <div>
                <div className="font-display text-lg font-medium">{j.title}</div>
                <div className="text-sm text-slate-400 mt-1 flex items-center gap-4">
                  <span className="flex items-center gap-1"><Briefcase className="w-3.5 h-3.5" />{j.company}</span>
                  <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{j.location}</span>
                </div>
                <div className="flex flex-wrap gap-1.5 mt-3">
                  {(j.required_skills || []).slice(0, 6).map((s) => (
                    <span key={s} className="text-xs px-2 py-0.5 rounded border border-white/10 text-slate-300">{s}</span>
                  ))}
                </div>
              </div>
              {j.salary_range && <div className="mono-label text-slate-300 shrink-0">{j.salary_range}</div>}
            </div>
          </Link>
        ))}
        {filtered.length === 0 && <div className="text-slate-500 text-sm">No jobs found.</div>}
      </div>
    </div>
  );
};
